'use es6';

import { View } from 'foundations-components/components/View';
import { INTEGRATIONS_APPS, getAppIdByAppName } from 'integrations-lib';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import H7 from 'UIComponents/elements/headings/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useShareThirdPartyApp } from '../../data/hooks/useShareThirdPartyApp';
import { useControlsContext } from './context';
import { SHARE_EMAIL } from './shareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ShareTabNavigation = () => {
  const {
    currentDialog,
    setCurrentDialog,
    setThirdPartyAppShareOptionSelection
  } = useControlsContext();
  const {
    data: slackApp
  } = useShareThirdPartyApp(getAppIdByAppName(INTEGRATIONS_APPS.SLACK));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareAsset.header"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsxs(UITabs, {
        "data-test-id": 'share-navigation',
        selected: currentDialog,
        onSelectedChange: ({
          target: {
            value
          }
        }) => {
          setCurrentDialog(value);
          setThirdPartyAppShareOptionSelection({});
        },
        children: [/*#__PURE__*/_jsx(UITab, {
          icon: "email",
          tabId: SHARE_EMAIL,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.emailReport.dialog.title"
          })
        }), /*#__PURE__*/_jsx(UITab, {
          "data-test-id": 'slack-navigation-tab',
          disabled: slackApp.connectionStatusTranslatedErrorMessage,
          icon: "socialSlack",
          tabId: getAppIdByAppName(INTEGRATIONS_APPS.SLACK),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.slackReport.dialog.title"
          })
        })]
      })
    })]
  });
};
export default ShareTabNavigation;